import styled from 'styled-components';
import { Dropdown as SemanticDropdown } from 'semantic-ui-react';

import { Text as TextLayout, colors } from '@playbookux/playbook-web-core';
import { Link as ReactRouterLink } from 'react-router-dom';

const {
  GRAY_TEXT, LINK_COLOR, RED,
} = colors;

export const Moderated = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
`;

export const TimezoneContainer = styled.div`
  display: flex;
  margin: auto;
  align-items: center;
  gap: 10px;
`;

export const DisclaimerContainer = styled.div`
  display: flex;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: ${(props) => props.theme.color.backgroundBanner};
`;

export const Disclaimer = styled(TextLayout)`
  color: #192c47;
`;

export const ModeratedRaw = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    margin-left: 10px;
  }
`;

const TextPrimary = styled(TextLayout)`
  margin-right: 8px;
  align-items: center;
  margin-bottom: 5px;
`;

export const Text = styled(TextPrimary)`
  text-align: center;
`;

export const Title = styled(Text)`
  color: ${GRAY_TEXT} !important;
  margin: 0 !important;
  text-align: center;
  font-size: 1.5em;
  font-weight: bolder;
`;

export const Link = styled(ReactRouterLink)`
  color: ${LINK_COLOR} !important;
  font-weight: bold;
  text-align: center;
  margin: 20px 0px;
  cursor: pointer;
`;

export const Warning = styled.span`
  color: ${RED} !important;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
`;

export const Dropdown = styled(SemanticDropdown)`
  &&& {

    &&:hover {
      background: ${({ theme }) => theme.color.white};

    }
    &.active {
      background: ${({ theme }) => theme.color.white};
    }
    &.ui.dropdown>.dropdown.icon{
      display: none;
    }
  }
`;
